import React from "react";
import styles from './DashboardDirectorCard.module.scss';
import PropTypes from "prop-types";
import {ReactComponent as Icon} from './Icon.svg';
import {ReactComponent as FileIcon} from './FileIcon.svg';
import { toCamelCase } from "../../utils/stringUtils";

const DashboardDirectorCard = ({
  title,
  type = 'Blue',
  count = {
    showIcon: false,
    count: 0
  },
  showIcon = false
}) => {
  return (
    <div className={`${styles.card} ${type ? styles[toCamelCase(type)] ?? '' : ''}`}>
      <h4>{title}</h4>
      <div className={styles.count}>
        {count.showIcon && <FileIcon />}
        <span className={`${styles.number} ${!showIcon && !count.showIcon ? styles.color : ''}`}>{count.count}</span>
      </div>
      {showIcon && <div className={styles.icon}>
        <Icon />
      </div>}
    </div>
  );
};

DashboardDirectorCard.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['Blue', 'Green', 'Red', 'Orange', 'BlueBG', 'GreenBG', 'OrangeBG']),
  count: PropTypes.shape({
    showIcon: PropTypes.bool,
    count: PropTypes.number.isRequired,
  }),
  showIcon: PropTypes.bool
};

export default DashboardDirectorCard;